import { Component, Input } from '@angular/core';

@Component({
  selector: 'partner-address-list-view',
  templateUrl: './partner-address-list-view.component.html',
  styleUrls: ['./partner-address-list-view.component.scss'],
  standalone: false,
})
export class PartnerAddressListViewComponent {
  @Input() public addresses: app.models.AddressProfileModel[];

  getFormattedAddress(address: app.models.AddressProfileModel): string {
    const parts = [
      address?.street,
      address?.localNumber,
      address?.buildingNumber,
      address?.stairNumber,
      address?.floorNumber,
      address?.flatNumber,
      address?.locality,
      address?.postalCode,
      address?.district,
      address?.country,
    ];

    return parts.filter(p => p && p !== '-').join(', ');
  }
}
